import type { FaireProductEntity } from "../../entity_types/product";

export const p_kxz6ptza2n: FaireProductEntity = {
  token: "p_kxz6ptza2n",
  type: "product",
  name: "Strapless sweetheart neckline with detachable lace bolero",
  brandToken: "b_1udwajl633",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/144697d935f78b22a18ddd5d277d81faaf2ef9f23a65afe075ca54bcb4677c55.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/680dd66f9fa6e513cf5ebaae9574631ca5c243bdb879578b61f2a053a74e765d.jpeg",
    "https://cdn.faire.com/fastly/c93509988c3ffc7b6136f2db0232db1be013dd521839038634837cc1302907ae.jpeg",
    "https://cdn.faire.com/fastly/b75bcc68f53bd684af23de5903b3ef39367bd175ff7a1e1e35928199a5e46aa8.jpeg",
    "https://cdn.faire.com/fastly/842a559dba942b2a48189980a0a7d7449e52c005e6cc11348982a58020b26f7d.jpeg",
    "https://cdn.faire.com/fastly/a032d54344e76440885ed50366939d4cec1a358483b0d7dadfe612636ed44b05.jpeg",
    "https://cdn.faire.com/fastly/fbf0558a9265020f1cccfbf87fd355b5af652b4a61d2b3a560445408ada753bf.jpeg",
  ],
  priceDollars: 304.85,
  description:
    "WL071:\nThis romantic fit-and-flare bridal gown features a delicately sequined lace overlay that trails down a curve-hugging silhouette. A sheer structured bodice enhances the hourglass shape, while the detachable lace bolero offers an elegant high neckline and long sleeves for added versatility. Finished with a dramatic lace-up back and a graceful sweep train, this gown is ideal for the bride seeking timeless beauty with a couture finish.\n\nSilhouette: Fit and flare\nDesign: Strapless sweetheart neckline with detachable high-neck lace bolero\nFabric & Material: Beaded lace overlay with soft nude underlay\nFit Detail: Sheer structured bodice with lace-up back and sweep train\nOccasions: Bridal gown, wedding ceremony, reception",
  tags: [],
  msrpDollars: 609.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:00.985Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
